angular
  .module("ticketco/common/section")
  .directive("tcSectionContainer", function () {
    return {
      restrict: "E",
      scope: {
        items: "<items",
        sectionData: "<section",
        plugins: "<",
        onRearrange: "&",
        onSelect: "&",
        onSelectionChange: "&",
        onUnselect: "&",
        onReady: "&",
        disabled: "<",
        selectionFilter: "<",
      },
      template:
        '<div class="tc-section-container">' +
        '<div class="arena-workspace" style="overflow:auto;">' +
        '<div class="arena-canvas-placeholder">' +
        '<div class="arena-canvas" style="transition:all 0.25s ease-out;">' +
        '<div class="scene-container">' +
        '<div class="scene">' +
        "<span></span>" +
        "</div>" +
        '<div class="arena-container"></div>' +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>" +
        "</div>",
      link: function (scope, element) {
        var section;
        var plugins = [
          window.SectionSeatsDOMRender,
          window.SectionDecorationsDOMRender,
          window.SectionNumberNavigation,
          new window.SectionScaleDesktop(),
          window.SectionScaleNavigation,
        ];

        element[0].style.display = "block";
        element[0].classList.add("arena");

        if (
          !angular.isDefined(scope.disabled) ||
          (angular.isDefined(scope.disabled) && scope.disabled === false)
        ) {
          plugins.push(window.SectionMultipleSeatsSelect);
        }

        plugins = scope.plugins || plugins;

        scope.selected = scope.selected || [];

        section = new window.Section({
          wrapper: ".tc-section-container",
          data: scope.sectionData,
          container: ".arena-container",
          plugins: plugins,
          selectionFilter:
            scope.selectionFilter ||
            R.allPass([
              R.pipe(
                R.prop("type"),
                R.includes(R.__, ["default", "handicap", "seating"])
              ),
              R.pipe(
                R.prop("status"),
                R.includes(R.__, ["available", "locked"])
              ),
            ]),
        });

        scope.onReady({
          $section: section,
        });

        function selectSeats(items) {
          section.setSelectedSeats(
            (items || []).map(function (item) {
              return item.row + "-" + item.seat;
            })
          );
        }

        function sectionRedrawSeats(items) {
          section.seatsData.seats = items;
          section.seatsWidth = 0;
          section.seatsHeight = 0;
          section.draw();
        }

        function sectionRedrawDecorations(decorations) {
          section.seatsData.decorations = decorations;
          section.seatsWidth = 0;
          section.seatsHeight = 0;
          section.draw();
        }

        scope.$watchCollection("sectionData.seats", sectionRedrawSeats);
        scope.$watchCollection(
          "sectionData.decorations",
          sectionRedrawDecorations
        );
        scope.$watchCollection("items", selectSeats);

        section.$.on("seat:select", function (_, data) {
          scope.onSelect({
            $seats: data,
          });
          scope.$apply();
        });

        section.$.on("seat:deselect", function (_, data) {
          scope.onUnselect({
            $seats: data,
          });
          scope.$apply();
        });

        section.$.on("seat:selectionChanged", function (_, data) {
          scope.onSelectionChange({
            $seats: data,
          });
          scope.$apply();
        });

        section.$.on("seat:rearrange", function (_, data) {
          scope.onRearrange({
            $seats: data,
          });
          sectionRedraw([data]);
          // scope.$apply();
        });

        element.on("$destroy", function () {
          section.destroy();
        });
      },
    };
  });
